import type { TopNavV6Props } from './TopNavV6Props'

export const defaultTopNavV6Props: TopNavV6Props = {
  logo: {
    src: '/images/bodi-by-bb-logo.svg',
    href: '/',
    altText: 'BODi logo',
    width: 100,
    height: 33,
  },
  navItems: [
    {
      title: 'Stream',
      href: '/s/subscription',
      authenticatedHref: 'https://bod-web-echo.qa.cd.beachbodyondemand.com/?locale=en_US',
    },
    {
      title: 'Shop',
      href: 'https://shop-us.qa.bodi.com',
    },
    {
      title: 'The BODi Experience',
      href: '/',
      isActive: true,
      navItems: [
        {
          title: 'Fitness',
          href: '/c/fitness',
          ctaButton: {
            title: 'Shop Fitness',
            href: '/c/fitness',
          },
          mobileCtaButton: {
            title: 'Shop Fitness',
            href: '/c/fitness',
          },
          navItems: {
            columns: [
              {
                title: 'Programs',
                items: [
                  {
                    title: 'The Power of 4',
                    href: '/s/fitness/the-power-of-4',
                    badge: 'New!',
                  },
                  {
                    title: 'Track Pilates',
                    href: '/s/fitness/track-pilates',
                    badge: 'New!',
                  },
                  {
                    title: 'Belle Vitale',
                    href: '/s/fitness/belle-vitale',
                  },
                  {
                    title: '25 Minute Speed Train',
                    href: '/s/fitness/25-minute-speed-train',
                  },
                  {
                    title: 'LIIFT4',
                    href: '/s/fitness/liift4',
                  },
                  {
                    title: 'P90X',
                    href: '/s/fitness/p90x',
                  },
                  {
                    title: 'DIG DEEPER',
                    href: '/s/fitness/dig-deeper',
                  },
                  {
                    title: 'Shop All',
                    href: '/c/fitness-programs',
                    isShopAll: true,
                  },
                ],
              },
              {
                title: 'Equipment',
                items: [
                  {
                    title: 'Pilates Equipment Bundle',
                    href: '/c/exercise-equipment',
                  },
                  {
                    title: 'Beachbody® Core Ball ',
                    href: '/c/exercise-equipment',
                  },
                  {
                    title: 'BOD® Rope',
                    href: '/c/exercise-equipment',
                  },
                  {
                    title: 'Control Track',
                    href: '/c/exercise-equipment',
                  },
                  {
                    title: 'Resistance Loops',
                    href: '/c/exercise-equipment',
                  },
                  {
                    title: 'Shop All',
                    href: '/c/exercise-equipment',
                    isShopAll: true,
                  },
                ],
              },
            ],
            violators: [
              {
                title: 'Coming November 17th',
                href: '/s/subscription#subscriptionOffers',
                stamp: 'DIG IN by Shaun T',
                image:
                  'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2Fa2e858c398a14fa0baedee1449d8cef7',
                alt: '',
                isVisible: true,
                newTab: false,
              },
            ],
            violatorGridSize: 1,
          },
        },
        {
          title: 'Nutrition',
          href: '/c/nutrition',
          ctaButton: {
            title: 'Shop Nutrition',
            href: '/c/nutrition',
          },
          mobileCtaButton: {
            title: 'Shop Nutrition',
            href: '/c/nutrition',
          },
          navItems: {
            columns: [
              {
                title: 'Shakeology All-in-One Nutrition',
                items: [
                  {
                    title: 'Original',
                    href: '/c/nutrition',
                  },
                  {
                    title: '0g Added Sugar',
                    href: '/c/nutrition',
                    badge: 'New Flavors!',
                  },
                  {
                    title: ' Sample Packs',
                    href: '/c/nutrition',
                  },
                ],
              },
              {
                title: 'Kits & Bundles ',
                items: [
                  {
                    title: 'Total Solution',
                    href: '/s/bundle/shakeology',
                    badge: 'Save 60%',
                  },
                  {
                    title: 'Belle Vitale All-in Kit',
                    href: '/s/fitness/belle-vitale',
                  },
                  {
                    title: 'The 4 Week Gut Protocol Complete Kit',
                    href: '/s/nutrition-plan/4-week-gut-protocol',
                  },
                ],
              },
              {
                title: 'Nutrition Plans',
                items: [
                  {
                    title: 'The 4 Week Gut Protocol',
                    href: '/s/nutrition-plan/4-week-gut-protocol',
                  },
                  {
                    title: 'Portion Fix',
                    href: '/s/nutrition-plan/portion-fix',
                  },
                  {
                    title: '2B Mindset',
                    href: '/s/nutrition-plan/2b-mindset',
                  },
                ],
              },
              {
                title: 'Program Materials',
                items: [
                  {
                    title: 'Belle Vitale Digital Recipe Book',
                    href: '/c/nutrition',
                  },
                  {
                    title: 'The 4 Week Gut Protocol Cookbook',
                    href: '/c/nutrition',
                  },
                  {
                    title: 'FIXATE Cookbook V1 & V2',
                    href: '/c/nutrition',
                  },
                  {
                    title: '"You Can Drop It!" 2B Mindset Book',
                    href: '/c/nutrition',
                  },
                  {
                    title: '2B Mindset Tracker',
                    href: '/c/nutrition',
                  },
                  {
                    title: 'Portion-Control Containers',
                    href: '/c/nutrition',
                  },
                ],
              },
            ],
            violators: [],
            violatorGridSize: 1,
          },
        },
        {
          title: 'Supplements',
          href: '/c/supplements',
          ctaButton: {
            title: 'Shop Supplements',
            href: '/c/supplements',
          },
          mobileCtaButton: {
            title: 'Shop Supplements',
            href: '/c/supplements',
          },
          navItems: {
            columns: [
              {
                title: 'Shakeology All-in-One Nutrition',
                items: [
                  {
                    title: 'Original',
                    href: '/c/supplements',
                  },
                  {
                    title: '0g Added Sugar',
                    href: '/c/supplements',
                    badge: 'New Flavors!',
                  },
                  {
                    title: ' Sample Packs',
                    href: '/c/supplements',
                  },
                ],
              },
              {
                title: 'Performance Nutrition',
                items: [
                  {
                    title: 'Energize Pre-Workout',
                    href: '/c/supplements',
                  },
                  {
                    title: 'Recover Post-Workout Protein',
                    href: '/c/supplements',
                  },
                  {
                    title: 'Hydrate Electrolytes',
                    href: '/c/supplements',
                  },
                ],
              },
              {
                title: 'Cleanses',
                items: [
                  {
                    title: '3 Day Refresh',
                    href: '/c/supplements',
                  },
                  {
                    title: 'Ultimate Reset',
                    href: '/c/supplements',
                  },
                ],
              },
            ],
            violators: [
              {
                title: 'Shop Now',
                href: '/c/supplements',
                stamp: 'Belle Vitale Supplement Duo',
                image:
                  'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F9f5c44d7891444569888f2d5e143cdde',
                alt: 'Belle Vitale Supplement Duo',
                isVisible: true,
                newTab: false,
              },
            ],
            violatorGridSize: 1,
          },
        },
        {
          title: 'View Plans',
          href: '/s/subscription',
          miniMenu: {
            items: [
              {
                title: 'Monthly Subscription',
                href: '/s/subscription?plan=monthly',
              },
              {
                title: 'Yearly Subscription',
                href: '/s/subscription?plan=yearly',
                badge: 'Save 20%',
              },
            ],
          },
        },
      ],
    },
  ],
  cartHref: 'https://shop-us.qa.bodi.com/cart',
  joinBodiHref: '/offers',
  loginLabel: 'Login',
  joinBodiLabel: 'Join BODi',
  instagramUrl: 'https://instagram.com/bodi',
  facebookUrl: 'https://facebook.com/bodi',
  youtubeUrl: 'https://youtube.com/@bodi',
  mobileHomeButtonText: 'Home',
  mobileSecondaryMenuItems: [
    {
      title: 'Home',
      href: '/',
      visibility: 'always',
    },
    {
      title: 'About Us',
      href: '/about',
      visibility: 'always',
    },
    {
      title: 'BODi Support',
      href: 'https://faq.bodi.com',
      visibility: 'always',
    },
    {
      title: 'My Account',
      href: 'https://my-account.shop-us.qa.bodi.com/profile',
      visibility: 'loggedIn',
    },
    {
      title: 'Live Chat',
      href: '#chat',
      visibility: 'always',
    },
  ],
  account: {
    title: 'Account & Support',
    loggedOutTitle: 'Login or Join BODi',
    loggedOutSubtitle: 'Workouts, nutrition, and much more.',
    welcomeCopy: 'Welcome back',
    signOutCopy: 'Sign out',
    logInCopy: 'Log in',
    bodiCta: {
      title: 'Join BODi',
      href: '/offers',
    },
    links: [
      {
        title: 'My Account',
        href: 'https://my-account.shop-us.qa.bodi.com/profile',
        newTab: true,
      },
      {
        title: 'My Orders',
        href: 'https://my-account.shop-us.qa.bodi.com/orders',
        newTab: true,
      },
      {
        title: 'My Subscriptions',
        href: 'https://my-account.shop-us.qa.bodi.com/pages/8cfdfe48-f906-45d6-8515-29818e34a6d4',
        newTab: true,
      },
      {
        title: 'BODi Support',
        href: 'https://faq.bodi.com',
        newTab: true,
      },
    ],
    loggedInLinks: [
      {
        title: 'BODi App',
        href: '/login-bodweb?locale=en_US',
        imageUrl:
          'https://cdn.builder.io/api/v1/image/assets%2F97e6e0cdd6a0493da63cf0b4cf432853%2F7382a7596e3e48cfb0bc48648db99446',
        imageAlt: 'bodi logo',
        subtitle: 'Your workouts, tracking & more',
      },
    ],
  },
}
